import { createFileRoute } from "@tanstack/react-router";

import LogSessionPage from "@/components/pages/LogSessionPage";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";

type LogTypeSearch = {
  coldStorageId?: string;
};

export const Route = createFileRoute("/_authenticated/logs/$logTypeId")({
  component: LogSessionRoute,
  validateSearch: (search: Record<string, unknown>): LogTypeSearch => ({
    coldStorageId:
      typeof search.coldStorageId === "string"
        ? search.coldStorageId
        : undefined,
  }),
});

function LogSessionRoute() {
  return (
    <FeatureGate feature={FEATURES.MONITORING} featureName="Monitoring">
      <LogSessionPage />
    </FeatureGate>
  );
}
